import { Signal } from '@angular/core';
import { LinkEntity } from 'src/app/domain/entities/link.entitty';
import { DataTagContext } from './data-tag-context.token';
import { getDataTagHint, getDataTagLabel } from './data-tag-i18n';
import { isDataTagFilled } from './data-tag-value.resolver';
import {
    setDataTagFilledResolver,
    setDataTagMetadata,
    setDataTagResolvers,
    updateDataTagValidityClasses,
} from './quill-data-tag';
import {
    setDataLinkFilledResolver,
    updateDataLinkValidityClasses,
} from './quill-link-placeholder';
import { TranslateService } from '@ngx-translate/core';

export type DataTagDisplaySyncOptions = {
    translate: TranslateService;
    links: LinkEntity[];
    contextSignal?: Signal<DataTagContext | null> | null;
    findLinkByTag: (tag: string) => LinkEntity | undefined;
};

export function syncDataTagDisplay(options: DataTagDisplaySyncOptions): void {
    const contextSignal = options.contextSignal;
    // Lê o contexto no momento da checagem (evita snapshot vazio do boot).
    const filled = (tag: string) => isDataTagFilled(tag, contextSignal?.() ?? null);

    setDataTagFilledResolver(filled);
    setDataLinkFilledResolver(filled);
    setDataTagResolvers(
        tag => {
            const link = options.findLinkByTag(tag);
            return getDataTagLabel(
                options.translate,
                tag,
                link?.description || link?.name
            );
        },
        tag => getDataTagHint(options.translate, tag) ?? options.findLinkByTag(tag)?.description
    );
    setDataTagMetadata(options.links);
}

export function refreshDataTagValidityInRoot(root: HTMLElement): void {
    updateDataTagValidityClasses(root);
    updateDataLinkValidityClasses(root);
}
